import React, { useEffect, useState } from "react";
import axios from "axios";
import { base_url } from "../../utils/axiosConfig";
import { BsCheckCircleFill } from "react-icons/bs";
import { GoClockFill } from "react-icons/go";
import { GoXCircleFill } from "react-icons/go";
import { BsBoxSeam } from "react-icons/bs";


const Dashboard = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const customer = localStorage.getItem("customer");
        if (!customer) {
          console.warn("No customer found, redirecting to login...");
          setLoading(false);
          return;
        }

        const parsedCustomer = JSON.parse(customer);
        const userId = parsedCustomer._id;

        if (!userId) {
          console.warn("No user id in customer object, redirecting to login...");
          setLoading(false);
          return;
        }

        const res = await axios.get(
          `${base_url}orders/delvery-boy/orders/${userId}`
        );

        setOrders(res.data.orders || []);
      } catch (error) {
        console.error("Error fetching orders for dashboard", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  // Stats
  const totalOrders = orders.length;
  const delivered = orders.filter((o) => o.orderStatus === "Delivered").length;
  const OutforDelivery = orders.filter((o) => o.orderStatus === "Out for Delivery").length;
  const cancelled = orders.filter((o) => o.orderStatus === "Cancelled").length;

  // Extract unique statuses dynamically
  const statusCounts = orders.reduce((acc, order) => {
    acc[order.orderStatus] = (acc[order.orderStatus] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="container-fluid py-3">
      <h3 className="mb-4 fw-semibold">📦 Delivery Dashboard</h3>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-2">Loading your stats...</p>
        </div>
      ) : (
        <>
          {/* Compact Stat Cards */}
          <div className="row g-3 mb-4">
            <div className="col-6 col-md-3">
              <div className="card border-0 shadow-sm rounded-3 text-center p-2">
                <BsBoxSeam className="text-primary fs-2 mb-1" />
                <h6 className="mb-0">Total Orders</h6>
                <p className="fw-bold fs-5 text-primary">{totalOrders}</p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 shadow-sm rounded-3 text-center p-2">
                <BsCheckCircleFill className="text-success fs-2 mb-1" />
                <h6 className="mb-0">Delivered</h6>
                <p className="fw-bold fs-5 text-success">{delivered}</p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 shadow-sm rounded-3 text-center p-2">
                <GoClockFill className="text-warning fs-2 mb-1" />
                <h6 className="mb-0">Out Of Delivered</h6>
                <p className="fw-bold fs-5 text-warning">{OutforDelivery}</p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 shadow-sm rounded-3 text-center p-2">
                <GoXCircleFill className="text-danger fs-2 mb-1" />
                <h6 className="mb-0">Cancelled</h6>
                <p className="fw-bold fs-5 text-danger">{cancelled}</p>
              </div>
            </div>
          </div>

          {/* Status Overview Chips */}
          <div className="card border-0 shadow-sm rounded-3 p-3">
            <h6 className="fw-semibold mb-3">Order Status Overview</h6>
            <div className="d-flex flex-wrap gap-2">
              {Object.keys(statusCounts).map((status) => (
                <span
                  key={status}
                  className={`badge rounded-pill px-3 py-2 ${
                    status === "Delivered"
                      ? "bg-success"
                      : status === "Cancelled"
                      ? "bg-danger"
                      : status === "Pending"
                      ? "bg-warning text-dark"
                      : "bg-secondary"
                  }`}
                >
                  {status} — {statusCounts[status]}
                </span>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
